import Controller from '@ember/controller';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

import styles from './styles.module.css';

export default class PaymentErrorController extends Controller {
  mainLayout = MainLayout;

  styles = styles;
}
